import { render, staticRenderFns } from "./zhifubao.vue?vue&type=template&id=3581585e&scoped=true"
import script from "./zhifubao.vue?vue&type=script&lang=js"
export * from "./zhifubao.vue?vue&type=script&lang=js"
import style0 from "./zhifubao.vue?vue&type=style&index=0&id=3581585e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581585e",
  null
  
)

export default component.exports